export const abrirNuevaSalida = () => {
  document.getElementById("sidebarNuevaSalida").style.display = "block";
  document.getElementById("myCol").style.display = "block";
  const columna1 = document.querySelector("#columna1");
  const sidebarNuevaSalida = document.querySelector("#sidebarNuevaSalida");

  if (columna1) {
    columna1.classList.remove("col-12");
    columna1.classList.add("col-9");
  }
  if (sidebarNuevaSalida) {
    if (!document.getElementById("contenedorPruebas")) return;
    document.getElementById("contenedorPruebas").style.display = "none";
  }
};

export const cerrarNuevaSalida = () => {
  if (!document.getElementById("sidebarNuevaSalida")) return;
  document.getElementById("sidebarNuevaSalida").style.display = "none";
  const cerrar = document.querySelector(".icono-cerrar");
  const columna1 = document.querySelector("#columna1");

  if (cerrar) {
    columna1.classList.remove("col-9");
    columna1.classList.add("col-12");
  }
};
export const CierraVentana = () => {
  document.getElementById("pruebas").style.display = "none";
  document.getElementById("contenedorPruebas").style.display = "none";
  const cerrar = document.querySelector(".icono-cerrar");
  const columna1 = document.querySelector("#columna1");

  if (cerrar) {
    columna1.classList.remove("col-9");
    columna1.classList.add("col-12");
  }
};
